// http://shoshin.sakura.ne.jp/wp/2016/11/05/mail-form-ajax/

jQuery(function($) {

  var $form = $('#js-ajax-form');
  if ($form.length) {
    var _statusStr = '処理中です...';
    var _statusHtml = '<div class="s-form-status" id="js-ajax-status"><p class="s-form-status__txt">' + _statusStr + '</p></div>';
    var _flag = false;
    $(document).on('click','#js-ajax-submit',function(e) {
      if (!$('#js-ajax-status').length) {
        $form.after(_statusHtml);
      }
      var $statusTxt = $('#js-ajax-status').find('.s-form-status__txt');
      var _mailStr = $form.find('input').val();
      if (_mailStr) {
        if (!(/^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi).test(_mailStr)) {
          _flag = false;
        } else {
          _flag = true;
        }
      }
      if (!$form.hasClass('is-disable')) {
        if (_flag) {
          var data = $form.serialize(); //送信されたデータ
          // console.log(data);
          $.ajax({
             type: 'POST',
             url: './mailer/js_submit.php', //PHPを呼び出す
             datatype: 'json',
             data: data, //記入されたデータを渡す
          }).done(function(data) {
            $form.addClass('is-processing');
          }).fail(function(data) {
            _statusStr = '送信に失敗しました';
            $form.addClass('is-failed');
            $statusTxt.text(_statusStr);
          }).always(function(data) {
            $form.removeClass('is-processing').addClass('is-disable');
            $form.find('input').prop('disabled', true);
            _statusStr = '送信が完了しました';
            $statusTxt.text(_statusStr);
            $('#js-ajax-status').addClass('is-finished');
            // $('#js-ajax-form').find("textarea, :text, input[type=email], select").val("").end().find(":checked").prop("checked", false);
          });
        } else {
          _statusStr = 'メールアドレスを正しく入力してください';
          $form.addClass('is-failed');
          $statusTxt.text(_statusStr);
        }
      }
        return false;
    });
  }
});
// window.addEventListener('load', function() {
//   'use strict';
//   var ajax = getXMLHttpRequestObject();//XMLHttpRequestインスタンスを作る
//   ajax.onreadystatechange = handleAjaxResponse;
//
//   document.getElementById('js-ajax-form').onsubmit = function() {
//     // js_submit.phpに送信するデータを作成する
//     var fields = ['mailaddress'];
//     var data = [];//空の配列
//     for(var i = 0; i < fields.length; i++) {
//       data.push(encodeURIComponent(fields[i]) + '=' + encodeURIComponent(document.getElementById(fields[i]).value));
//     }
//
//     ajax.open('POST', './mailer/js_submit.php', true);
//     ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
//     ajax.send(data);
//     // ajax.send(data.join('&'));
//     return false;// フォームからの実際の送信をとめる
//
//   }; // onsubmit無名関数の終わり
// }, false); // load無名関数の終わり
//
// function getXMLHttpRequestObject() {
//   var ajax = null;
//
//   if (window.XMLHttpRequest) {
//     ajax = new XMLHttpRequest();
//   } else if (window.ActiveXObject) {// 古いIE
//     ajax = new ActiveXObject('MSXML2.XMLHTTP.3.0');
//   }
//
//   return ajax;
// }
//
// function handleAjaxResponse(e) {
//   'use strict';
//   if(typeof e == 'undefined') e = window.event;
//   var ajax = e.target || e.srcElement;
//
//   if (ajax.readyState == 4) {
//     if((ajax.status == 102)) {
//       document.getElementById('js-ajax-form').classList.add('is-doing');
//     }
//     if((ajax.status >= 200 && ajax.status < 300) || (ajax.status == 304)) {
//       // ステータスOKの場合、
//       document.getElementById('js-ajax-form').classList.remove('is-doing');
//       alert('送信しました！');// 仮のメッセージ。後で書き換える
//       // alert(ajax.responseText);
//
//     } else {
//       // ステータスエラーの場合、通常のメール送信（post）を行う
//       document.getElementById('js-ajax-form').submit();
//     }
//     ajax = null;
//   }
// }
